import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import AdminSideMenu from "../../navbar/AdminSideMenu";
import AdminTopMenu from "../../navbar/AdminTopMenu";
import DataTable from "react-data-table-component";
import { customTableStylesForSummery } from "../../common/customTableStyles";
import { getDiscountSettingList, getMasterCountryList } from "../../../api/api";

const countrySelectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: "42px",
    borderRadius: "0.375rem",
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "#696cff"
      : state.isFocused
        ? "rgba(105, 108, 255, 0.12)"
        : "#fff",
    color: state.isSelected ? "#fff" : "#4b5563",
  }),
  menu: (base) => ({ ...base, zIndex: 20 }),
};

const parsePgArray = (value) => {
  if (!value) return "";
  return value
    .replace(/[{}"]/g, "")
    .split(",")
    .filter(Boolean)
    .join(", ");
};

const DiscountSetting = () => {
  const { id } = useParams();

  const [error, seterror] = useState({
    errarStatus: false,
    errorMessage: "",
    bgcolor: "",
  });

  const [discountList, setDiscountList] = useState([]);
  const [pending, setPending] = useState(true);
  const [countryList, setCountryList] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState([]);

  const [formData, setFormData] = useState({
    mincount: "",
    holdtime: "",
    senderIds: "",
    deliveryRatio: "",
    failRatio: "",
  });

  const countryOptions = countryList.map((items) => ({
    value: items.country_code,
    label: `${items.country_name} (${items.country_code})`,
  }));

  const getDiscountSetting = () => {
    getDiscountSettingList().then((res) => {
      if (res.data.success === true) {
        setDiscountList(res.data.data);
        setPending(false);
      } else {
        seterror({
          errarStatus: true,
          errorMessage: res.data.message,
          bgcolor: "alert alert-danger",
        });
        setPending(false);
      }
    });
  };

  useEffect(() => {
    getDiscountSetting();
    getMasterCountryList().then((res) => {
      if (res.data.success === true) {
        setCountryList(res.data.data);
      } else {
        setCountryList([]);
      }
    });
  }, []);

  const handleMinCountChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setFormData((prev) => ({ ...prev, mincount: value }));
  };

  const handleHoldTimeChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setFormData((prev) => ({ ...prev, holdtime: value }));
  };

  const handleHoldTimeBlur = () => {
    setFormData((prev) => ({
      ...prev,
      holdtime:
        prev.holdtime && parseInt(prev.holdtime, 10) < 5
          ? "5"
          : prev.holdtime,
    }));
  };

  const handleSenderIdsChange = (e) => {
    setFormData((prev) => ({ ...prev, senderIds: e.target.value }));
  };

  const handleDeliveryRatioChange = (e) => {
    const raw = e.target.value.replace(/[^0-9]/g, "");
    if (raw === "") {
      setFormData((prev) => ({ ...prev, deliveryRatio: "", failRatio: "" }));
      return;
    }
    const value = Math.min(parseInt(raw, 10), 100);
    setFormData((prev) => ({
      ...prev,
      deliveryRatio: String(value),
      failRatio: String(100 - value),
    }));
  };

  const handleFailRatioChange = (e) => {
    const raw = e.target.value.replace(/[^0-9]/g, "");
    if (raw === "") {
      setFormData((prev) => ({ ...prev, deliveryRatio: "", failRatio: "" }));
      return;
    }
    const value = Math.min(parseInt(raw, 10), 100);
    setFormData((prev) => ({
      ...prev,
      failRatio: String(value),
      deliveryRatio: String(100 - value),
    }));
  };

  const submitHandler = () => {
    const payload = {
      system_id: id,
      mincount: parseInt(formData.mincount || 0, 10),
      holdtime: parseInt(formData.holdtime || 0, 10),
      delivery_ratio_percentage: parseInt(formData.deliveryRatio || 0, 10),
      fail_ratio_percentage: parseInt(formData.failRatio || 0, 10),
      sender_json: formData.senderIds
        .split(",")
        .map((senderId) => senderId.trim())
        .filter(Boolean),
      country_codejson: selectedCountries.map((option) => option.value),
    };
    console.log("Discount Setting payload", payload);
  };

  const columns = [
    {
      name: "System ID",
      selector: (row) => row.system_id,
      sortable: true,
    },
    {
      name: "Min Count",
      selector: (row) => row.minpacket,
      sortable: true,
    },
    {
      name: "Hold Time",
      selector: (row) => row.holdtime,
      sortable: true,
    },
    {
      name: "Percentage",
      selector: (row) => row.percentage,
      sortable: true,
    },
    {
      name: "Delivery Ratio %",
      selector: (row) => row.delivery_ratio_percentage,
      sortable: true,
    },
    {
      name: "Fail Ratio %",
      selector: (row) => row.fail_ratio_percentage,
      sortable: true,
    },
    {
      name: "Sender IDs",
      selector: (row) => parsePgArray(row.sender_json),
      wrap: true,
    },
    {
      name: "Country Codes",
      selector: (row) => parsePgArray(row.country_codejson),
      wrap: true,
    },
  ];

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <AdminSideMenu />

        <div className="layout-page">
          <AdminTopMenu />

          <div className="content-wrapper">
            <div className="container-xxl container-p-y">
              {error.errarStatus ? (
                <div className={error.bgcolor} role="alert">
                  <strong>Alert!</strong> {error.errorMessage}
                </div>
              ) : null}

              <div className="card mb-4">
                <h5 className="card-header d-flex justify-content-between align-items-center">
                  Add Discount Setting
                  <Link to="/admin/user-list" className="btn btn-primary btn-sm">
                    <FontAwesomeIcon icon={faArrowLeft} /> Go Back
                  </Link>
                </h5>
                <hr className="m-0" />
                <div className="card-body">
                  <div className="row gy-3">
                    <div className="col-md-4">
                      <label className="form-label">Username</label>
                      <input
                        type="text"
                        className="form-control"
                        value={id}
                        disabled
                      />
                    </div>

                    <div className="col-md-4">
                      <label className="form-label">
                        Minimum Count
                      </label>
                      <input
                        type="text"
                        inputMode="numeric"
                        className="form-control"
                        placeholder="Enter minimum count"
                        value={formData.mincount}
                        onChange={handleMinCountChange}
                      />
                    </div>

                    <div className="col-md-4">
                      <label className="form-label">Hold Time</label>
                      <input
                        type="text"
                        inputMode="numeric"
                        className="form-control"
                        placeholder="Minimum 5"
                        value={formData.holdtime}
                        onChange={handleHoldTimeChange}
                        onBlur={handleHoldTimeBlur}
                      />
                      <div className="form-text text-info">
                        Hold time cannot be less than 5.
                      </div>
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">Country</label>
                      <Select
                        isMulti
                        isSearchable
                        closeMenuOnSelect={false}
                        options={countryOptions}
                        value={selectedCountries}
                        onChange={(selected) =>
                          setSelectedCountries(selected || [])
                        }
                        placeholder="Select countries"
                        noOptionsMessage={() => "No countries found"}
                        styles={countrySelectStyles}
                        classNamePrefix="country-select"
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">Sender ID</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Example : 1234, 5678, 9810"
                        value={formData.senderIds}
                        onChange={handleSenderIdsChange}
                      />
                      <div className="form-text text-info">
                        Enter multiple sender IDs separated by commas.
                      </div>
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">
                        Delivery Percentage Ratio
                      </label>
                      <input
                        type="text"
                        inputMode="numeric"
                        className="form-control"
                        placeholder="Enter Delivery Percentage Ratio"
                        value={formData.deliveryRatio}
                        onChange={handleDeliveryRatioChange}
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">
                        Failed Percentage Ratio
                      </label>
                      <input
                        type="text"
                        inputMode="numeric"
                        className="form-control"
                        placeholder="Enter Failed Percentage Ratio"
                        value={formData.failRatio}
                        onChange={handleFailRatioChange}
                      />
                      <div className="form-text text-info">
                        Delivery and Failed ratio always add up to 100.
                      </div>
                    </div>

                    <div className="col-md-12 text-right">
                      <button
                        type="button"
                        onClick={submitHandler}
                        className="btn btn-primary mt-3"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card pb-5">
                <h5 className="card-header">Discount Setting</h5>
                <DataTable
                  pagination
                  handleSort
                  columns={columns}
                  data={discountList}
                  progressPending={pending}
                  customStyles={customTableStylesForSummery}
                  noDataComponent="No Discount Setting Found"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiscountSetting;
